import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import ApprovalStepStatusText from './ApprovalStepStatusText';
import ApprovalUserAvatar from '../user/ApprovalUserAvatar';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import FormattedDate from './FormattedDate';
import { Text } from 'foundations-components/components/Text';
import { BubbleIcon } from 'foundations-assets/icons/components/BubbleIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalStepsListItem(props) {
  const {
    approvalStep
  } = props;
  return /*#__PURE__*/_jsxs(TFlex, {
    "data-test-id": "approval-steps-list-item",
    children: [/*#__PURE__*/_jsx(ApprovalUserAvatar, {
      approvalUser: approvalStep.approver
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      marginInlineStart: "300",
      "data-test-id": `product-approvals-steps-list-item-${approvalStep.approvalStepStatus}`,
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(ApprovalUserFormattedName, {
          approvalUser: approvalStep.approver
        })
      }), /*#__PURE__*/_jsxs(TFlex, {
        marginBlockStart: "100",
        children: [/*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(ApprovalStepStatusText, {
            approvalStepStatus: approvalStep.approvalStepStatus
          })
        }), approvalStep.approvedNote && /*#__PURE__*/_jsx(Tooltip, {
          use: "longform",
          placement: "bottom",
          title: /*#__PURE__*/_jsxs(Text, {
            as: "p",
            typography: "detail-100",
            children: [approvalStep.approvedNote, /*#__PURE__*/_jsx("br", {}), approvalStep.approvedNoteTimestamp && /*#__PURE__*/_jsx(FormattedDate, {
              date: approvalStep.approvedNoteTimestamp
            })]
          }),
          children: /*#__PURE__*/_jsx(BubbleIcon, {
            "data-test-id": "approval-steps-list-item-info",
            color: "icon-core-subtle"
          })
        })]
      }), approvalStep.rejectionNote && /*#__PURE__*/_jsx(Paragraph, {
        marginBlockStart: "300",
        marginBlockEnd: "0",
        "data-test-id": "approval-steps-list-item-reject-note",
        children: approvalStep.rejectionNote
      })]
    })]
  });
}
export default ApprovalStepsListItem;